import React, { useState } from 'react';
import { Lock, LogIn, AlertCircle } from 'lucide-react';
import { api, setToken } from './api';

export default function PanelLogin({ onAuth }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await api('/login', { method: 'POST', auth: false, body: { email, password } });
      setToken(data.access_token);
      onAuth(data.admin);
    } catch (err) {
      setError(err.message || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 px-4" data-testid="papa-login">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center mb-6">
          <span className="text-2xl font-extrabold text-white tracking-tight">PitBoard<span className="text-sky-400">.</span></span>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl shadow-2xl p-7 space-y-5">
          <div className="flex items-center gap-2 text-slate-900">
            <span className="w-9 h-9 rounded-xl bg-slate-900 text-white flex items-center justify-center"><Lock size={16} /></span>
            <div>
              <h1 className="font-bold text-lg leading-none">Espace interne</h1>
              <p className="text-xs text-slate-500 mt-1">Accès réservé</p>
            </div>
          </div>

          {error && (
            <div className="flex items-start gap-2 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="papa-login-error">
              <AlertCircle size={16} className="mt-0.5 flex-shrink-0" /> {error}
            </div>
          )}

          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1">E-mail</label>
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              data-testid="papa-login-email"
              className="w-full px-3 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500"
              placeholder="vous@exemple.com" autoComplete="email"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1">Mot de passe</label>
            <input
              type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              data-testid="papa-login-password"
              className="w-full px-3 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500"
              placeholder="••••••••" autoComplete="current-password"
            />
          </div>

          <button
            type="submit" disabled={loading}
            data-testid="papa-login-submit"
            className="w-full flex items-center justify-center gap-2 bg-slate-900 text-white font-semibold text-sm py-2.5 rounded-lg hover:bg-slate-800 transition-colors disabled:opacity-60"
          >
            <LogIn size={16} /> {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}
